import {IEngagementType} from '../types/CreateProjectFormTypes';

export const getSelectedEngagement = (types: IEngagementType[], id: string): string =>
  types?.find((type: IEngagementType) => +type.id === +id)?.name || '';

export const canShowProjectCode = (engagementTypes: IEngagementType[], engagementType: string): boolean =>
  !['', 'None'].includes(getSelectedEngagement(engagementTypes, engagementType));

export const NONE_ENGAGEMENT = '3';
